import { render, staticRenderFns } from "./BuyOrdersSend.vue?vue&type=template&id=c4a5a818&"
import script from "./BuyOrdersSend.vue?vue&type=script&lang=js&"
export * from "./BuyOrdersSend.vue?vue&type=script&lang=js&"
import style0 from "./BuyOrdersSend.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports